<template>
  <router-view />
  <FloatingBannerStack>
    <UpdateAvailableBanner />
    <InstallPromptBanner />
  </FloatingBannerStack>
  <ToastList />
  <ConfirmDialog />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';
import FloatingBannerStack from '@/components/FloatingBannerStack.vue';
import UpdateAvailableBanner from '@/components/UpdateAvailableBanner.vue';
import InstallPromptBanner from '@/components/InstallPromptBanner.vue';
import ToastList from '@/components/ToastList.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';

const authStore = useAuthStore();

onMounted(async () => {
  // Check if user has a valid session on app mount
  await authStore.checkAuth();
});
</script>
